import AOS from 'aos';

jQuery(function ($) {
    // Accordion logic
    $('.a-header').on('click', function () {

        // If user clicked on an open accordion
        if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $(this).next().slideUp();
            $(this).find('i').removeClass('fa-minus').addClass('fa-plus');
        }
        // User clicked on closed accordion
        else {
            // Setup some vars to make life easy peezy
            var $thisH = $(this);
            var $thisB = $(this).next();
            var $thisI = $(this).find('i');

            // Close all open accords
            const $accordionHeaders = $('.single-accordion .a-header');
            const $accordionBody = $('.single-accordion .a-body');
            const $accordionIcon = $('.single-accordion .a-header i');

            $accordionBody.slideUp();
            $accordionHeaders.removeClass('open');
            $accordionIcon.removeClass('fa-minus').addClass('fa-plus');

            // Open the clicked accord
            $thisB.slideDown();
            $thisH.addClass('open');
            $thisI.removeClass('fa-plus').addClass('fa-minus');
        }
    });
    // Open the first accordion on load

    // Spam prevention technique
    // Submits the form if fake-input is empty
    $('.form-with-fi').on('submit', function () {
        if ($('[name="fi"]').val().length != 0) {
            return !1
        }
    })

    // Accordion controller
    $('.accordion-block').on('click', function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            $('.accordion-block.active').removeClass('active');
            $(this).addClass('active');
        }
    });

    // AOS (Fade in animation lib)
    AOS.init();

    if ($('#sidebar').length) {
        var topSpace = 100;
        var bottomSpace = $('footer').outerHeight() + $('.cta-section').outerHeight() + 110;
        $("#sidebar").sticky({topSpacing: topSpace, bottomSpacing: bottomSpace});
    }
});

// Sticky sidebar functionality
function initStickySidebar() {
    const sidebar = document.querySelector('.is-style-side-bar-list');
    const totalTopOffset = 150; // Navigation menu + extra space between sidebar

    if (!sidebar) {
        return;
    }

    const sidebarInitialTop = sidebar.getBoundingClientRect().top + window.scrollY;

    window.addEventListener('scroll', function () {
        const windowTop = window.scrollY;
        const documentHeight = document.documentElement.scrollHeight;
        const windowHeight = window.innerHeight;
        const stickyStartPoint = sidebarInitialTop - totalTopOffset;
        const stickyEndPoint = documentHeight - windowHeight;

        if (windowTop >= stickyStartPoint && windowTop <= stickyEndPoint) {
            sidebar.classList.add('stick');
            sidebar.style.top = totalTopOffset + 'px';
        } else {
            sidebar.classList.remove('stick');

            if (windowTop < stickyStartPoint) {
                sidebar.style.top = '';
            } else if (windowTop > stickyEndPoint) {
                sidebar.style.top = '';
            }
        }

        sidebar.querySelectorAll('li').forEach(listItem => {
            const anchor = listItem.querySelector('a');
            if (!anchor) return;

            const sectionId = anchor.getAttribute('href');

            if (sectionId && sectionId.startsWith('#')) {
                const targetSection = document.querySelector(sectionId);
                if (!targetSection) return;

                const sectionOffset = targetSection.getBoundingClientRect().top + window.scrollY - totalTopOffset;

                if (sectionOffset <= windowTop) {
                    const activeItem = sidebar.querySelector('li.active');
                    if (activeItem) {
                        activeItem.classList.remove('active');
                    }
                    listItem.classList.add('active');
                }
            }
        });
    });
}

// Observer for Animation Sections

const options = {
    threshold: 0.9
};

function callbackFunc(entires) {
    entires.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add('animate-aos');
        }
    });
}

const observer = new IntersectionObserver(callbackFunc, options)

function initIntersectionAnimation () {
    const animationElements = document.querySelectorAll('[class^="animate-aos-"], [class*=" animate-aos-"]');
    animationElements.forEach((el) => observer.observe(el));
}

function initToggleJobs() {
    const toggleBtn = document.getElementById("toggle-jobs");
    const hiddenJobs = document.querySelectorAll(".hidden-job");

    if (toggleBtn) {
        toggleBtn.addEventListener("click", function () {
            hiddenJobs.forEach(job => {
                job.style.display = job.style.display === "flex" ? "none" : "flex";
            });

            if (toggleBtn.textContent === "View All") {
                toggleBtn.textContent = "Hide";
            } else {
                toggleBtn.textContent = "View All";
            }
        });
    }
}

function initSmoothScrollHashOnPageLoad() {
    if (window.location.hash) {
        const headerHeight = document.querySelector('#toolbox-theme-navigation')?.offsetHeight || 0

        const target = document.querySelector(window.location.hash)
        if (target) {
            const targetPosition = target.getBoundingClientRect().top + window.scrollY
            const offsetPosition = targetPosition - headerHeight

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    }
}

function normalize(str) {

    if (!str) return '';

    return decodeURIComponent(str)
        .replace(/[–—]/g, '-')     // normalize unicode dashes
        .replace(/[\s-]+/g, '-')   // convert spaces AND dashes → single dash
        .trim()
        .toLowerCase();
}

// Addresses the bug caused job titles with - to not be correctly matched with the position dropdown, causing some positions to not be autofilled
function initJobDropdownFix() {
    if (!window.location.pathname.includes('/jobs/apply-now')) return;

    const params = new URLSearchParams(window.location.search);
    const jobParam = params.get('j');
    if (!jobParam) return;

    const normalizedParam = normalize(jobParam);

    // WAIT for position multiselect to load in DOM completely
    const interval = setInterval(() => {

        const multiselect = document.querySelector('.position-select .multiselect');

        if (!multiselect) return;

        clearInterval(interval);

        const toggle = multiselect.querySelector('.multiselect__select');

        if (toggle) toggle.click();

        setTimeout(() => {

            const options = multiselect.querySelectorAll(
                '.multiselect__option:not(.multiselect__option--disabled)'
            );

            for (const option of options) {
                const text = option.innerText.trim();
                const normalizedOption = normalize(text);
                if (normalizedOption === normalizedParam) {
                    option.click();
                    break; // stop after match
                }
            }

        }, 100);

    }, 200);
}





document.addEventListener('DOMContentLoaded', (event) => {
    initStickySidebar();
    initIntersectionAnimation();
    initToggleJobs();
    initSmoothScrollHashOnPageLoad();
    initJobDropdownFix();
});
